import React, { useMemo } from 'react';
import block from 'bem-cn';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import SVG from 'components/SVG';
import SVGInline from 'react-svg-inline';
import Switcher from 'components/Switcher/Switcher';
import { actions as authActions } from 'features/Auth';
import { items } from './data';

import logoutSVG from './img/logout.svg';
import userSVG from './img/user.svg';

import './ProfileBlock.scss';

const b = block('profile-block');

const ProfileBlock = () => {
  const dispatch = useDispatch();
  const locale = useSelector(state => state.locale.locale);
  const auth = useSelector(state => state.auth);

  const logout = () => {
    dispatch(authActions.logOut());
  };

  const handleHigherAgentsOperationsSwitch = () => {
    dispatch(authActions.toggleHigherAgentsOperationsRestricted());
  };

  const itemsList = useMemo(
    () =>
      items.map(item => (
        <Link key={item.name} className={b('item')} to={`${item.link}/${auth.id}`}>
          <SVG className={b('item-icon').toString()} svgProps={{ svg: item.svg }} />
          <span className={b('item-value')}>{locale[item.title]}</span>
        </Link>
      )),
    [locale],
  );

  return (
    <div className={b()}>
      <div className={b('left')}>
        <div className={b('user')}>
          <SVGInline svg={userSVG} className={b('user-img').toString()} />
          <div className={b('user-block', { first: true })}>
            <span>{locale.login}</span>
            <span>{auth.username}</span>
          </div>
        </div>

        <div className={b('user-block')}>
          <span>ID</span>
          <span>{auth.id}</span>
        </div>

        <div className={b('user-block')}>
          <span>{locale.balance}:</span>
          <span>{auth.balance}</span>
        </div>
      </div>

      <div className={b('right')}>
        <div className={b('right-inner')}>
          <div className={b('actions')}>
            {itemsList}
            <div className={b('item')} onClick={logout}>
              <SVG className={b('item-icon').toString()} svgProps={{ svg: logoutSVG }} />
              <span className={b('item-value')}>{locale.logout}</span>
            </div>
          </div>
          <div className={b('superior-switch')}>
            <div className={b('superior-switch-wrap')}>
              <Switcher
                isActive={!auth.isHigherAgentsOperationsRestricted}
                onSwitch={handleHigherAgentsOperationsSwitch}
                color="purple"
              />
            </div>
            <span className={b('superior-switch-label')}>{locale.isHigherAgentsOperationsRestricted}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileBlock;
